export default {
  pages: {
    managerApplications: {
      title: 'Barcha arizalar',
    },
  },
};
